
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dining",
      function () {
        return require("private-next-pages/dining.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dining"])
      });
    }
  